import { toggleAttributeBoolean } from '@utils';

class CollapsibleElement extends HTMLElement {
  /** @type {HTMLElement} */ #controller = this.querySelector('[aria-controls]');
  /** @type {HTMLElement} */ #target = this.#controller.ariaControlsElements[0];

  connectedCallback() {
    this.#controller.addEventListener('click', () => this.#handleClick());
  }

  #handleClick() {
    toggleAttributeBoolean(this.#controller, 'aria-expanded');
    toggleAttributeBoolean(this.#target, 'aria-hidden');
  }
}

customElements.define('collapsible-element', CollapsibleElement);
